import clsx from 'clsx'
import moment from 'moment'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {WhiteButton, BlueButton} from './buttons'
import {faStickyNote} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"


const useStyles = makeStyles(editCommentStyles)

export default function EditComment (props) {

  const {translate} = props.context
  const classes = useStyles()
  const date = props.added
    ? moment(props.added).format(translate('assessment-sent-on-format'))
    : translate('new-annotation')

  return (
    <Box className={classes.root}>
      <Box className={classes.date}>
        <span className={clsx(classes.middle, "icon")}><FontAwesomeIcon icon={faStickyNote} /></span>
        <span className={`${classes.middle} ${classes.dateLabel}`}>{date}</span>
      </Box>
      <Box className={classes.comment}>
        <textarea autoFocus value={props.comment} onChange={props.onChange} />
      </Box>
      <Box className={classes.buttons}>
        <WhiteButton onClick={props.onCancel} className={classes.cancel}>
          {translate('cancel_label')}
        </WhiteButton>
        <BlueButton onClick={props.onSave}>
          {translate('save_label')}
        </BlueButton>
      </Box>
    </Box>
    )
}

function editCommentStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      border: 'solid 1px #c2c7ca',
      borderRadius: '4px',
      padding: '20px',
      [theme.breakpoints.down('sm')]: {
        padding: '10px'
      }
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      "&.icon": {
        fontSize: '12pt',
        marginTop: -3,
        color: '#647f90'
      }
    },
    date: {
      display: 'flex',
      flexShrink: 0,
      color: '#647f90',
      fontSize: '12pt',
    },
    dateLabel: {
      marginLeft: '10px',
      paddingTop: '2px'
    },
    comment: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: '100px',
      marginTop: '10px',
      '& > textarea': {
        resize: 'none',
        flexGrow: 1,
        borderRadius: '4px',
        border: 'solid 1px #c2c7ca',
      }
    },
    buttons: {
      paddingTop: '20px',
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '10px',
        justifyContent: 'center',
      }
    },
    save: {
      width: '120px'
    },
    cancel: {
      width: '120px',
      marginRight: '30px',
      [theme.breakpoints.down('sm')]: {
        marginRight: '20px',
      }
    }
  };
}

